/* eslint-disable */
import { bus } from '../../../main';
var $ = window.jQuery = require('jquery');
import toast from '../../../services/toast';
export default {
  name: 'contest-quiz-section-config',
  components: {},
  props: [],
  data () {
    return {
      difficulty_level:'',
      submitted:false
    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
    createSectionsSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            quiz_section:this.$route.params.quiz_sectionId,
            difficulty_level: this.difficulty_level,
          }
          this.$store.dispatch('createdSectionConfigForQuizFun', data)
          .then((res) => {
            this.name = '',
            toast.success(res.data.msg);
            this.$router.push({ name: 'contestQuizzesSectionUpdate', params: {quiz_catId:this.$route.params.quiz_catId, quizId: this.$route.params.quizId, quiz_sectionId: this.$route.params.quiz_sectionId } })
            this.$validator.reset();
            })
            .catch((err) => {})
          return
        }
      });
    },
  }
}


